<div
popperHelp
helpOrder="13"
helpContent="This will show the active property, you can also change the active property from this tool."
helpPlacement="right"
  class="grid gap-4"
>
  <app-property-select></app-property-select>

      <button class="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 grid grid-flow-col gap-4 items-center" *ngIf="needsDownloading$ | async" (click)="downloadLayersClick()">Download Reference Layers <i class="fa fa-download"></i></button>
</div>

